import {InlineBannerTypesEnum} from '../../components/banners/inlineBanner/inlineBannerTypes';
import {greys, greysDark} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {
  redesignedDarkBackgroundSemanticStyles,
  redesignedLightBackgroundSemanticStyles,
} from './backgroundSemanticStyles';

export type InlineBannerVariantStyles = Record<
  InlineBannerTypesEnum,
  {
    backgroundColor: string;
    iconColor: string;
  }
>;

export interface InlineBannerSemanticStyles extends InlineBannerVariantStyles {
  titleColor: string;
  textColor: string;
}

export const lightInlineBannerSemanticStyles = {
  [InlineBannerTypesEnum.INFO]: {
    backgroundColor: colorPrimitive.blue[200],
    iconColor: colorPrimitive.blue[700],
  },
  [InlineBannerTypesEnum.SUCCESS]: {
    backgroundColor: colorPrimitive.green[200],
    iconColor: colorPrimitive.green[600],
  },
  [InlineBannerTypesEnum.WARNING]: {
    backgroundColor: redesignedLightBackgroundSemanticStyles.surface.warning,
    iconColor: redesignedLightBackgroundSemanticStyles.fill.warningHover,
  },
  [InlineBannerTypesEnum.ERROR]: {
    backgroundColor: colorPrimitive.red[200],
    iconColor: colorPrimitive.red[700],
  },
  [InlineBannerTypesEnum.UPSELL]: {
    backgroundColor: colorPrimitive.purple[200],
    iconColor: colorPrimitive.purple[700],
  },

  titleColor: greys.shade90,
  textColor: greys.shade80,
} as const satisfies InlineBannerSemanticStyles;

export const redesignedLightInlineBannerSemanticStyles = {
  ...lightInlineBannerSemanticStyles,
  [InlineBannerTypesEnum.INFO]: {
    backgroundColor: colorPrimitive.blurple[200],
    iconColor: colorPrimitive.blurple[700],
  },
  [InlineBannerTypesEnum.UPSELL]: {
    backgroundColor: colorPrimitive.purple[200],
    iconColor: colorPrimitive.purple[700],
  },
};

export const darkInlineBannerSemanticStyles = {
  [InlineBannerTypesEnum.INFO]: {
    backgroundColor: colorPrimitive.blue[900],
    iconColor: colorPrimitive.blue[500],
  },
  [InlineBannerTypesEnum.SUCCESS]: {
    backgroundColor: colorPrimitive.green[900],
    iconColor: colorPrimitive.green[500],
  },
  [InlineBannerTypesEnum.WARNING]: {
    backgroundColor: redesignedDarkBackgroundSemanticStyles.surface.warning,
    iconColor: redesignedDarkBackgroundSemanticStyles.fill.warningHover,
  },
  [InlineBannerTypesEnum.ERROR]: {
    backgroundColor: colorPrimitive.red[900],
    iconColor: colorPrimitive.red[500],
  },
  [InlineBannerTypesEnum.UPSELL]: {
    backgroundColor: colorPrimitive.purple[900],
    iconColor: colorPrimitive.purple[500],
  },

  titleColor: greysDark.shade90,
  textColor: greysDark.shade90,
} as const satisfies InlineBannerSemanticStyles;

export const redesignedDarkInlineBannerSemanticStyles = {
  ...darkInlineBannerSemanticStyles,
  [InlineBannerTypesEnum.INFO]: {
    backgroundColor: colorPrimitive.blurple[900],
    iconColor: colorPrimitive.blurple[500],
  },
  [InlineBannerTypesEnum.UPSELL]: {
    backgroundColor: colorPrimitive.purple[900],
    iconColor: colorPrimitive.purple[500],
  },
};
